import { SEAT_FILL_COLOR } from '%paysera_seat_selection/js/seatSelection/config/defaults';

const SEATING_MAP_PADDING = 20;
const SEATING_HOVER_BORDER_COLOR = '#000000';
const SEATING_FILL_COLOR_PURCHASED = '#0475DD';
const SEATING_FILL_COLOR_RESERVED = '#FFFFFF';
const SEATING_FILL_COLOR_DISABLED = SEAT_FILL_COLOR;

const TEXT_COLOR_CONTRAST_DARK = '#FFFFFF';
const TEXT_COLOR_CONTRAST_LIGHT = '#000000';

const LONG_PRESS_DURATION = 1000;

export {
    SEATING_MAP_PADDING,
    SEATING_HOVER_BORDER_COLOR,
    SEATING_FILL_COLOR_PURCHASED,
    SEATING_FILL_COLOR_RESERVED,
    SEATING_FILL_COLOR_DISABLED,
    TEXT_COLOR_CONTRAST_DARK,
    TEXT_COLOR_CONTRAST_LIGHT,
    LONG_PRESS_DURATION,
};
